export interface IReelStatesState {
    active: boolean;
    reelSetsData: Array<Array<number>>;
}

export interface IReelSetsReel {
    reelSet: Array<number>;
    noOfSymbols: number;
    reelStopIndex: number;
    reelIndex: number;
}

export const ReelStatesDefault = {
    active: false,
    reelSetsData: []
};
